<template>
    <v-card elevation="0" class="" prepend-icon="mdi-lock" align="left" v-if="!goalReached" color="info" variant="tonal" height="90px" >
    <template v-slot:title>
      <span class="text-subtitle-2 font-weight-bold text-uppercase " >{{ $t("unlock_free_shipping") }}</span>
    </template>
    <div class="pa-0 pl-4 pr-4 mb-2" align="left">
      <div class="text-subtitle-2">
        {{ $t("spend")}} €{{(this.goalAmount - this.currentAmount).toFixed(2)}} {{ $t("more_to_unlock") }} 
      </div>
      <v-progress-linear
        :model-value="progress"
        height="10"
        :color="goalReached ? 'success' : 'info'"
        rounded
        striped
        class="transition-fast-in-fast-out"
      >
      </v-progress-linear>
    </div>
    </v-card>
  </template>
  
  <script>


  
  export default {
    components:{
       
    },
    props: {
        currentAmount: {
        type: Number,
        required: true,
        },
        goalAmount: {
        type: Number,
        required: true,
        },
    },
    data() {
      return {

      };
    },
    watch: {
            
    },
    computed:{
        progress() {
      return Math.min(100, Math.round((this.currentAmount / this.goalAmount) * 100));
        },
        goalReached() {
        return this.currentAmount >= this.goalAmount;
        },
        progressText() {
        const remaining = (this.goalAmount - this.currentAmount).toFixed(2);
        return `Spend €${remaining} more to unlock.`;
        },
    },
    methods: {

    }
  };
  </script>
  
  <style scoped>

  </style>